import { Activity } from 'lucide-react';

import { Badge } from '@/components/shadcn/ui/badge';
import { cn } from '@/lib/cn';
import { Tooltip } from '@/shared/ui';

type Props = {
  title: string;
  tooltip: string;
  className?: string;
};
export function SignalBadge({ title, tooltip, className }: Props) {
  return (
    <Tooltip content={tooltip} side="bottom">
      <Badge className={cn('flex gap-0.5 items-center max-w-36', className)} variant="secondary">
        <Activity className="size-3" />
        <span className="truncate">{title}</span>
      </Badge>
    </Tooltip>
  );
}
